import promotionsService from './ws';

export default promotionsService;